export enum PACKAGE_STATES {
  CREATED = 'CREATED',
  VERIFIED = 'VERIFIED',
  INCOMPLETE = 'INCOMPLETE',
  DISPATCHED = 'DISPATCHED',
  DISPATCH = 'DISPATCH',
}
